import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-5">
      <div className="text-center">
        <div className="font-display text-redflag text-[20vw] leading-none">!</div>
        <h1 className="font-display uppercase text-3xl md:text-5xl mt-4">
          404 — Nicht gefunden
        </h1>
        <p className="mt-4 text-white/55">Diese Seite existiert nicht.</p>
        <Link
          to="/"
          className="btn-primary inline-flex mt-8 px-5 py-3 text-sm uppercase tracking-wide"
        >
          Zur Startseite
        </Link>
      </div>
    </div>
  );
}
